import { Component } from '@angular/core';
import { Constants } from 'src/app/models/constants';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent {

  year: string;

  Constants = Constants;

  constructor() {
  }

  ngOnInit(): void {
    this.year = new Date().getFullYear().toString();
  }
}

